import layout from '../../Layout';

export default class Header {
  constructor(options, settings) {
    this.header = options.header;
    this.menuToggle = options.menuToggle;
    this.postMessage = options.postMessage;

    this.settings = settings;
    this.transitioning = false;

    this.stickyClass = 'site-header--sticky';
    this.navOpenClass = 'site-header-nav--open';

    this.menu = this.header.querySelector('[data-site-navigation]');

    this._toggleMenu = this._toggleMenu.bind(this);

    if (this.settings.sticky_header) {
      this.header.classList.add(this.stickyClass);
    }

    this.toggleClick = (event) => {
      event.preventDefault();
      if (layout.isBreakpoint('L')) this._toggleMenu();
    };

    this.menuToggle.addEventListener('click', this.toggleClick);
  }

  closeNavigation() {
    if (this.transitioning) { return; }

    this.menuToggle.classList.remove('active');

    this.navTransitionOutEvent = () => {
      this.header.classList.remove(this.navOpenClass);
      this.transitioning = false;
      this.menu.removeEventListener('transitionend', this.navTransitionOutEvent);
    };

    this.menu.addEventListener('transitionend', this.navTransitionOutEvent);

    this.transitioning = true;
    this.menu.setAttribute('style', `margin-top: -${this.menu.getBoundingClientRect().height}px;`);

    this.postMessage('nav:close-all');
  }

  openNavigation() {
    if (this.transitioning || this.header.classList.contains(this.navOpenClass)) { return; }

    this.menuToggle.classList.add('active');

    this.navTransitionInEvent = () => {
      this.transitioning = false;
      this.menu.removeEventListener('transitionend', this.navTransitionInEvent);
    };

    this.menu.addEventListener('transitionend', this.navTransitionInEvent);

    this.transitioning = true;

    // We need to wait for the browser to set the display to 'block' before we set the margin
    // This will help with ensuring the different animations/transitions happen in sequence
    // and not at the same time.
    window.requestAnimationFrame(() => {
      this.header.classList.add(this.navOpenClass);

      window.requestAnimationFrame(() => {
        this.menu.setAttribute('style', 'margin-top: 0;');
      });
    });
  }

  _toggleMenu() {
    if (this.header.classList.contains(this.navOpenClass)) {
      this.closeNavigation();
    } else {
      this.openNavigation();
    }
  }

  unload() {
    this.header.classList.remove(this.stickyClass);
    this.menuToggle.removeEventListener('click', this.toggleClick);
  }

  sectionDeselect() {
    // Do nothing
  }
}
